const base = (process.env.REACT_APP_SERVER_URL || "").trim().replace(/\/$/, "");

export async function secretSantaRequest(path, session, body) {
  if (!base) throw new Error("Set REACT_APP_SERVER_URL in the portal environment and restart the frontend.");
  const response = await fetch(`${base}/api/admin/secret-santa${path}`, {
    method: body === undefined ? "GET" : "POST",
    headers: { "Content-Type": "application/json",
      ...(session ? { "X-Secret-Santa-Session": session } : {}) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    cache: "no-store",
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.error || "Secret Santa is unavailable. Try again.");
    error.status = response.status;
    throw error;
  }
  return result;
}

export function subscribeSecretSantaParticipants(onParticipants, onError) {
  const controller = new AbortController();
  let timer;
  let delay = 1000;

  async function connect() {
    if (controller.signal.aborted) return;
    let reader;
    try {
      const response = await fetch(`${base}/api/admin/secret-santa/participants/stream`, {
        headers: { Accept: "text/event-stream" },
        cache: "no-store", signal: controller.signal,
      });
      if (!response.ok || !response.body) {
        const error = new Error("Unable to connect to live participants.");
        error.status = response.status;
        throw error;
      }
      reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      while (!controller.signal.aborted) {
        const { value, done } = await reader.read();
        if (done) throw new Error("Live participant connection closed. Reconnecting…");
        buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, "\n");
        let end;
        while ((end = buffer.indexOf("\n\n")) !== -1) {
          const event = buffer.slice(0, end);
          buffer = buffer.slice(end + 2);
          const data = event.split("\n").filter((line) => line.startsWith("data:")).map((line) => line.slice(5).trimStart()).join("\n");
          if (!data) continue;
          const payload = JSON.parse(data);
          if (payload.error) throw new Error(payload.error);
          if (Array.isArray(payload.participants) && !controller.signal.aborted) {
            delay = 1000;
            onParticipants(payload.participants);
          }
        }
      }
    } catch (error) {
      if (!controller.signal.aborted) {
        onError(error);
        if (![401, 403, 423].includes(error.status)) {
          timer = setTimeout(connect, delay);
          delay = Math.min(delay * 2, 30000);
        }
      }
    } finally {
      if (reader) { await reader.cancel().catch(() => {}); reader.releaseLock(); }
    }
  }

  if (!base) onError(new Error("Set REACT_APP_SERVER_URL before connecting to live participants."));
  else connect();
  return () => { controller.abort(); clearTimeout(timer); };
}
